import { render, staticRenderFns } from "./mktWarning.vue?vue&type=template&id=1beadc7d&"
import script from "./mktWarning.vue?vue&type=script&lang=js&"
export * from "./mktWarning.vue?vue&type=script&lang=js&"
import style0 from "./mktWarning.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports